import React, { ChangeEvent, useEffect, useState } from 'react'

import { NewCheckBoxButton } from '../UI/NewCheckBoxButton/NewCheckBoxButton'
import styles from './InvestmentFilter.module.scss'

const name = 'type'

function InvestmentFilterRooms(props: {
  filterHandler(value: string, name: string, checked?: boolean): void
  startValue: string
  nameEventReset: string
}) {
  const { filterHandler, startValue, nameEventReset } = props
  const [activeBtn, setActiveBtn] = useState<string>('')

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    filterHandler(value, name)
    setActiveBtn(value)
  }

  const roomOptions = [
    { label: 'Студия', value: 'studio', class: ['text'] },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    // { label: '3', value: '3' },
  ]

  return (
    <div className={styles['filter-item']}>
      <span className={styles['filter-item__name']}>Комнатность</span>
      <div className={styles['filter-row']}>
        {roomOptions.map(option => (
          <NewCheckBoxButton
            key={option.value}
            type='radio'
            name={name}
            label={option.label}
            value={option.value}
            checked={activeBtn === option.value}
            onChange={changeHandler}
            classes={option.class ? option.class : []}
            nameEventReset={nameEventReset}
          />
        ))}
      </div>
    </div>
  )
}

export default InvestmentFilterRooms
